function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, react/style-prop-object */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedNumber, FormattedMessage, IntlProvider } from 'react-intl';
import { Checkbox } from 'module-tsl-ui-elements';
import { emitClick } from '../utils/MzHelper';
import { amount, price as priceType } from './types';

var getPriceWithCurrencySymbol = function getPriceWithCurrencySymbol(price, symbol) {
  return /*#__PURE__*/React.createElement("span", null, "".concat(symbol).concat(price));
};

getPriceWithCurrencySymbol.displayName = "getPriceWithCurrencySymbol";

var formatAmount = function formatAmount(_ref) {
  var currencySymbol = _ref.symbol,
      priceAmount = _ref.amount,
      code = _ref.code;
  var fixedAmount = priceAmount.toFixed(2);
  if (code === 'AUD' || code === 'CAD' || code === 'NZD') return "$".concat(fixedAmount, " ").concat(code);
  return "".concat(currencySymbol).concat(fixedAmount);
};

var MultiTeacherLicence = /*#__PURE__*/function (_Component) {
  _inherits(MultiTeacherLicence, _Component);

  var _super = _createSuper(MultiTeacherLicence);

  function MultiTeacherLicence() {
    _classCallCheck(this, MultiTeacherLicence);

    return _super.apply(this, arguments);
  }

  _createClass(MultiTeacherLicence, [{
    key: "onChangeLicenceCheckbox",
    value: function onChangeLicenceCheckbox() {
      if (!this.props.isMultiTeacherLicence) {
        emitClick(global, 'school-licence-select', 'select school licence');
      }

      this.props.setMultiTeacherLicence(!this.props.isMultiTeacherLicence);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var cardCharge = this.props.cardCharge;
      var total;
      var singlePrice = this.props.singlePrice.amount;

      if (!this.props.schoolLicPrice) {
        // only do this in case we dont have a schoolLicPrice (unexpected)
        total = 3.5 * singlePrice;
      } else {
        total = this.props.schoolLicPrice.amount;
      }

      var extra = total - singlePrice;
      var extraFormatted = /*#__PURE__*/React.createElement(FormattedNumber, {
        value: extra,
        minimumFractionDigits: 2,
        format: this.props.singlePrice.code,
        style: "decimal"
      }, function (priceAsString) {
        return getPriceWithCurrencySymbol(priceAsString, _this.props.singlePrice.symbol);
      });
      var addLicence = /*#__PURE__*/React.createElement("div", {
        className: "mb-1"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        id: "schoolLicId2",
        onChange: function onChange() {
          return _this.onChangeLicenceCheckbox();
        },
        checked: this.props.isMultiTeacherLicence
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "schoolLicId2"
      }, "Add School Licence for +", extraFormatted));
      return /*#__PURE__*/React.createElement(IntlProvider, null, /*#__PURE__*/React.createElement("section", {
        className: "mb-4 pt-2"
      }, addLicence, /*#__PURE__*/React.createElement("p", {
        className: "color-k-60"
      }, "This licence allows you to share this resource with colleagues at your school.")));
    }
  }], [{
    key: "onInfoClick",
    value: function onInfoClick() {
      emitClick(global, 'school-licence-info-link', 'school-licence-info');
    }
  }]);

  return MultiTeacherLicence;
}(Component);

MultiTeacherLicence.displayName = "MultiTeacherLicence";
MultiTeacherLicence.propTypes = {
  singlePrice: priceType,
  schoolLicPrice: priceType,
  isMultiTeacherLicence: PropTypes.bool.isRequired,
  setMultiTeacherLicence: PropTypes.func.isRequired,
  cardCharge: amount.isRequired
};
export default MultiTeacherLicence;